/*
 todo: general:
 1. Popup
 2. Keyboard support
 3. custom-class attribute support
 4. date-disabled attribute support
 5. template-url attribute support
 */
export { DatePickerComponent } from './datepicker.component';
export { DatepickerModule } from './datepicker.module';
export { DayPickerComponent } from './daypicker.component';
export { MonthPickerComponent } from './monthpicker.component';
export { YearPickerComponent } from './yearpicker.component';
export { DateFormatter } from './date-formatter';
export { DatepickerConfig } from './datepicker.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/ngx-bootstrap/datepicker/index.js
// module id = ../../../../ngx-bootstrap/datepicker/index.js
// module chunks = 13